import { connectorsByIdentifier } from "./index";

const managedOAuthBase = "https://credentials.tines.com/webhook";

export const managedOAuthOrigin = new URL(managedOAuthBase).origin;

// Connectors whose credentials story lives at a dedicated webhook path rather
// than the shared oauth-redirect/oauth-return dispatcher.
const customCredentialsStories: Record<
  string,
  { begin: string; return: string }
> = {
  slackUser: {
    begin: `${managedOAuthBase}/slack-user-oauth/go`,
    return: `${managedOAuthBase}/slack-userbot-return/go`,
  },
};

function toKebabCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/_/g, "-")
    .toLowerCase();
}

function credentialsServiceType(identifier: string): string | undefined {
  const oauth = connectorsByIdentifier[identifier]?.oauth;
  if (oauth?.clientCredentialsFrom !== "env") return undefined;
  return oauth.credentialsServiceType;
}

export function envOAuthClientKey(identifier: string): string {
  if (identifier.startsWith("google")) return "google";
  return identifier;
}

export const managedOAuthUrl = (provider: string) => {
  const custom = customCredentialsStories[provider];
  if (custom) return `${custom.begin}?is_cloud=true`;
  if (provider.includes("google")) {
    return `${managedOAuthBase}/google-begin/go?type=${provider.toLowerCase()}&is_cloud=true`;
  }
  const type = credentialsServiceType(provider) ?? toKebabCase(provider);
  return `${managedOAuthBase}/oauth-redirect/go?type=${type}&is_cloud=true`;
};

export const managedOAuthRedirectUri = (provider: string) => {
  const custom = customCredentialsStories[provider];
  if (custom) return custom.return;
  if (provider.includes("google")) {
    return `${managedOAuthBase}/google-return/go`;
  }
  return `${managedOAuthBase}/oauth-return/go`;
};
